import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

const apiUri = environment.basePath + '/cgu/signataire/';

@Injectable({
  providedIn: 'root'
})
export class CguService {

  private httpOptions = {
    withCredentials: true,
    observe: 'response' as 'response',
    headers: new HttpHeaders()
  };

  constructor(
    private _http: HttpClient,
  ) { }

  public async getCguDecision(signataireId: string): Promise<CguSignataireDecision> {
    try {
      const res = await this._http.get<CguSignataireDecision>(`${apiUri}${signataireId}`, this.httpOptions).toPromise();
      return res.body;
    } catch (error) {
      throw error;
    }
  }

  public async saveCguDecision(signataireId: string, statut: DecisionStateEnum): Promise<void> {
    try {
      const options = {...this.httpOptions};
      options['params'] = { hasAcceptedCurrentCgu: statut };
      await this._http.post<CguSignataireDecision>(`${apiUri}${signataireId}`, undefined, options).toPromise();
    } catch (error) {
      throw error;
    }
  }

  public async getHistoriqueCguDecision(signataireId: string): Promise<Array<HistoriqueCguSignataireDecision>> {
    try {
      const res = await this._http.get<Array<HistoriqueCguSignataireDecision>>(`${apiUri}${signataireId}/historique`, this.httpOptions).toPromise();
      return res.body;
    } catch (error) {
      throw error;
    }
  }

  public getDecisionStateEnumLabel(decisionState: DecisionStateEnum): string {
    switch (decisionState) {
      case DecisionStateEnum.Accepte:
        return "Accepté";
      case DecisionStateEnum.Refuse:
        return "Refusé";
      case DecisionStateEnum.ResetAdmin:
        return "Réinitialisé par l'administrateur";
      case DecisionStateEnum.NonSigne:
        return "Non signé";
      default:
        return "Non signé";
    }
  }

}

export interface CguSignataireDecision {
  currentCguDecisionState: DecisionStateEnum;
  currentCguContent?: string;
}

export enum DecisionStateEnum {
  Accepte = "accepte",
  Refuse = "refuse",
  ResetAdmin = "reset_admin",
  NonSigne = "non_signe",
}

export interface HistoriqueCguSignataireDecision {
  decisionState: DecisionStateEnum;
  decisionDate: Date;
  cguVersion: string;
}
